import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  private handleReload = (): void => {
    window.location.reload();
  };

  private handleReset = (): void => {
    this.setState({ hasError: false, error: null });
  };

  render(): ReactNode {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1.5rem',
          background: '#f8f9fa',
        }}
      >
        <div style={{ textAlign: 'center', maxWidth: '28rem' }}>
          <svg
            style={{ width: 56, height: 56, margin: '0 auto 1rem', color: '#d93025' }}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>

          <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#202124', marginBottom: '0.5rem' }}>
            오류가 발생했습니다
          </h1>
          <p style={{ fontSize: '0.875rem', color: '#5f6368', marginBottom: '1.5rem' }}>
            예기치 않은 오류로 인해 화면을 표시할 수 없습니다.
          </p>

          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={this.handleReset}
              style={{
                padding: '0.625rem 1.25rem',
                background: '#1a73e8',
                color: '#fff',
                border: 'none',
                borderRadius: '0.5rem',
                fontWeight: 500,
                fontSize: '0.875rem',
                cursor: 'pointer',
              }}
            >
              다시 시도
            </button>
            <button
              onClick={this.handleReload}
              style={{
                padding: '0.625rem 1.25rem',
                background: '#fff',
                color: '#202124',
                border: '1px solid #e8eaed',
                borderRadius: '0.5rem',
                fontWeight: 500,
                fontSize: '0.875rem',
                cursor: 'pointer',
              }}
            >
              페이지 새로고침
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
